import { injectReducer } from 'commons/stores';

import { searchReducer } from './state';

export const withAnalyticsSearch = <T>(Component: T): T =>
  // @ts-ignore
  injectReducer({ key: 'analytics/search', reducer: searchReducer })(Component);
